import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-deletion-list',
  templateUrl: './deletion-list.component.html',
  styleUrls: ['./deletion-list.component.scss'],
  standalone: false,
})
export class DeletionListComponent {
  @Input() items: any[] = [];
  @Input() displayProperties: string[] = ['name'];
  @Output() remove = new EventEmitter<any>();
  @Input() showDeleteButton: boolean = true;

  constructor() {}

  onRemove(item: any): void {
    this.remove.emit(item);
  }

  shouldShowDeleteButton(): boolean {
    return this.showDeleteButton || this.items.length > 1;
  }
}
